import { api } from '@/lib/api';

export interface Notification {
  id: string;
  recipientId: string;
  type: string;
  title: string;
  body: string;
  link: string | null;
  isRead: boolean;
  readAt: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

interface NotificationsResponse {
  items: Notification[];
  total: number;
  page: number;
  limit: number;
}

export const notificationsApi = {
  getAll: (page = 1, limit = 5) =>
    api.get<NotificationsResponse>('/notifications', { params: { page, limit } }).then((r) => r.data),

  getUnreadCount: () =>
    api.get<{ count: number }>('/notifications/unread-count').then((r) => r.data.count),

  markAsRead: (id: string) =>
    api.patch(`/notifications/${id}/read`).then((r) => r.data),

  markAllAsRead: () =>
    api.patch('/notifications/read-all').then((r) => r.data),
};
